import { tokens } from '@servicetitan/tokens/core';

const indexedTokens: { [index: string]: string } = tokens;

const colorRemap: Map<string, string> = new Map([
    ['colorNeutral200', 'colorNeutral60'],
    ['colorNeutral300', 'colorNeutral70'],
    ['colorNeutral400', 'colorNeutral90'],
    ['colorNeutral500', 'colorNeutral200'],
    ['colorNeutral600', 'colorNeutral400'],
]);

export const getColorPalette = () => {
    const colorTypes = [
        'Red',
        'Orange',
        'Yellow',
        'Green',
        'Cyan',
        'Blue',
        'Magenta',
        'Purple',
        'Neutral',
    ];
    const [rangeStart, rangeEnd] = [200, 600];
    const colors = [];
    for (let i = rangeStart; i <= rangeEnd; i += 100) {
        colors.push(
            ...colorTypes.map(color => {
                const colorCode = `color${color}${i}`;
                return indexedTokens[color === 'Neutral' ? colorRemap.get(colorCode)! : colorCode];
            })
        );
    }
    return colors.filter(color => color).map(color => color.toLowerCase());
};
